import { useSelector, useDispatch } from 'react-redux';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import { selectAlertState, clearAlert } from '../../redux/slices/alertSlice';

function AlertBar() {
  const dispatch = useDispatch();
  const { message, type, open } = useSelector(selectAlertState);

  if (!open || !message || !type) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => dispatch(clearAlert())}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={type}
        variant="filled"
        sx={{ width: '100%' }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => dispatch(clearAlert())}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default AlertBar;
